import { render, staticRenderFns } from "./MyRequests.vue?vue&type=template&id=766f3f07&scoped=true"
import script from "./MyRequests.vue?vue&type=script&lang=ts"
export * from "./MyRequests.vue?vue&type=script&lang=ts"
import style0 from "./MyRequests.vue?vue&type=style&index=0&id=766f3f07&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766f3f07",
  null
  
)

export default component.exports